import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function DataProtectionPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Política de Protección de Datos
            </h1>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition-colors font-semibold whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </button>
          </div>
          <p className="text-gray-600 mb-12">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Responsable del Tratamiento de Datos</h2>
              <div className="bg-emerald-50 p-6 rounded-lg">
                <p className="text-gray-700"><strong>Identidad:</strong> PROTECPLUS INGENIERÍA</p>
                <p className="text-gray-700"><strong>Dirección postal:</strong> Avenida de Madrid, 86 Nave 3 - 28500 Arganda del Rey, Madrid</p>
                <p className="text-gray-700"><strong>Correo electrónico:</strong> info@protecplus.es</p>
                <p className="text-gray-700"><strong>Teléfono:</strong> +34 900 123 456</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Principios Aplicables al Tratamiento de Datos</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                El tratamiento de los datos personales del usuario se someterá a los siguientes principios recogidos en el RGPD:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li><strong>Licitud, lealtad y transparencia:</strong> Se requerirá en todo momento el consentimiento del usuario previa información completamente transparente</li>
                <li><strong>Limitación de la finalidad:</strong> Los datos serán recogidos con fines determinados, explícitos y legítimos</li>
                <li><strong>Minimización de datos:</strong> Los datos serán adecuados, pertinentes y limitados a lo necesario</li>
                <li><strong>Exactitud:</strong> Los datos deben ser exactos y estar actualizados</li>
                <li><strong>Limitación del plazo de conservación:</strong> Los datos solo se mantendrán el tiempo necesario</li>
                <li><strong>Integridad y confidencialidad:</strong> Los datos serán tratados de manera que se garantice su seguridad</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Obtención de Datos Personales</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Los datos personales que tratamos en PROTECPLUS INGENIERÍA proceden de:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Formularios de contacto del sitio web</li>
                <li>Solicitudes de información y presupuestos</li>
                <li>Contratación de servicios</li>
                <li>Comunicaciones por email o teléfono</li>
                <li>Formularios de inscripción a cursos de formación</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Derechos del Usuario</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Cualquier persona tiene derecho a obtener confirmación sobre si en PROTECPLUS INGENIERÍA estamos tratando datos personales que les conciernan. Las personas interesadas tienen derecho a:
              </p>
              <ul className="list-disc pl-6 space-y-3 text-gray-700">
                <li><strong>Derecho de acceso:</strong> Derecho a obtener información sobre sus datos personales</li>
                <li><strong>Derecho de rectificación:</strong> Derecho a que se modifiquen los datos inexactos o incompletos</li>
                <li><strong>Derecho de supresión:</strong> Derecho a solicitar la eliminación de sus datos</li>
                <li><strong>Derecho a la limitación del tratamiento:</strong> Derecho a que se suspendan determinadas operaciones de tratamiento</li>
                <li><strong>Derecho a la portabilidad:</strong> Derecho a recibir los datos en un formato estructurado y de uso común</li>
                <li><strong>Derecho de oposición:</strong> Derecho a oponerse al tratamiento de sus datos</li>
                <li><strong>Derecho a no ser objeto de decisiones automatizadas:</strong> Derecho a no ser objeto de decisiones basadas únicamente en el tratamiento automatizado</li>
              </ul>
              <div className="bg-blue-50 p-6 rounded-lg mt-6">
                <p className="text-gray-700 font-semibold mb-2">¿Cómo ejercer sus derechos?</p>
                <p className="text-gray-700">
                  Puede ejercer sus derechos enviando un correo electrónico a <strong>info@protecplus.es</strong> o mediante comunicación escrita a nuestra dirección postal, adjuntando copia de su DNI o documento equivalente.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Finalidad del Tratamiento de Datos</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Los datos personales serán utilizados para las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Gestionar las consultas realizadas a través de los formularios de contacto</li>
                <li>Enviar información sobre nuestros servicios (con consentimiento previo)</li>
                <li>Gestionar la contratación de servicios</li>
                <li>Gestionar inscripciones a cursos de formación</li>
                <li>Enviar comunicaciones comerciales (con consentimiento previo)</li>
                <li>Cumplir con obligaciones legales</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Plazo de Conservación de Datos</h2>
              <p className="text-gray-700 leading-relaxed">
                Los datos personales proporcionados se conservarán mientras se mantenga la relación comercial o durante los años necesarios para cumplir con las obligaciones legales. Los datos proporcionados se conservarán mientras no se solicite su supresión por el interesado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Destinatarios de Datos</h2>
              <p className="text-gray-700 leading-relaxed">
                Los datos no se comunicarán a ningún tercero ajeno a PROTECPLUS INGENIERÍA, salvo obligación legal. No se realizan transferencias internacionales de datos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Datos de Menores de Edad</h2>
              <p className="text-gray-700 leading-relaxed">
                Nuestros servicios no están dirigidos a menores de 14 años. En caso de que se detecte que se han recogido datos de menores sin el consentimiento de los padres o tutores, se procederá a su eliminación inmediata.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Secreto y Seguridad de los Datos</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA se compromete al uso y tratamiento de los datos personales del usuario, respetando su confidencialidad y a utilizarlos de acuerdo con la finalidad del mismo, así como a dar cumplimiento a su obligación de guardarlos y adaptar todas las medidas para evitar la alteración, pérdida, tratamiento o acceso no autorizado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Reclamaciones</h2>
              <p className="text-gray-700 leading-relaxed">
                Si considera que sus derechos no han sido atendidos debidamente, puede presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) a través de su sede electrónica o dirección postal:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4">
                <p className="text-gray-700"><strong>Agencia Española de Protección de Datos</strong></p>
                <p className="text-gray-700">C/ Jorge Juan, 6</p>
                <p className="text-gray-700">28001 Madrid</p>
                <p className="text-gray-700">Web: www.aepd.es</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Aceptación y Consentimiento</h2>
              <p className="text-gray-700 leading-relaxed">
                El usuario declara haber sido informado de las condiciones sobre protección de datos personales, aceptando y consintiendo el tratamiento de los mismos por parte de PROTECPLUS INGENIERÍA en la forma y para las finalidades indicadas en esta Política de Protección de Datos.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
